import React from "react";
import { FaWallet, FaUserCircle } from "react-icons/fa";

/**
 * Top-of-checkout segmented control that picks the WALLET SOURCE —
 * external (MetaMask / Coinbase / WalletConnect / etc. via wagmi)
 * vs. Horus (custodial, via the logged-in Horus account).
 *
 * This is orthogonal to the payment-method choice (x402 vs direct),
 * which is surfaced separately by <MethodSwitcher /> inside the
 * external-wallet flow. Horus always settles via a direct custodial
 * transfer — the backend `signTransaction` Lambda doesn't sign
 * EIP-712 typed data yet, so the in-source method switcher is
 * hidden on that path.
 *
 * Hidden when only one source is usable for this link (e.g. a
 * native-token link excludes Horus, which only supports ERC-20).
 */
export function WalletSourceSwitcher({
  activeSource,
  canUseHorus,
  canUseExternal,
  onSwitch,
}) {
  if (!canUseHorus || !canUseExternal) return null;

  const Item = ({ source, icon: Icon, label }) => {
    const isActive = source === activeSource;
    return (
      <button
        type="button"
        className={
          "pay-wallet-source__btn" +
          (isActive ? " pay-wallet-source__btn--active" : "")
        }
        onClick={() => !isActive && onSwitch(source)}
        aria-pressed={isActive}
      >
        <Icon size={14} />
        <span>{label}</span>
      </button>
    );
  };

  return (
    <div className="pay-wallet-source" role="tablist">
      <Item source="horus" icon={FaUserCircle} label="Horus Wallet" />
      <Item source="external" icon={FaWallet} label="Connect Wallet" />
    </div>
  );
}
